
export default {
    props: {
        show: {
            required: true,
            default: false,
            type: Boolean
        },
        icon: {
            required: false,
            default: '',
            type: String
        },
        title: {
            required: false,
            default: '',
            type: String
        },
        buttonTextConfirm: {
            required: false,
            default: '',
            type: String
        },
        buttonIconConfirm: {
            required: false,
            default: '',
            type: String
        },
        buttonColorConfirm: {
            required: false,
            default: 'primary',
            type: String
        },
        buttonTextColorConfirm: {
            required: false,
            default: 'var(--v-primary-text-base)',
            type: String
        },
        buttonTextCancel: {
            required: false,
            default: '',
            type: String
        },
        layout: {
            required: false,
            default: 'chain',
            type: String
        },
        hideActions: {
            required: false,
            default: false,
            type: Boolean
        }
    },
}
